import '../vendor';

import './notice/notice';
import './notice/notice-scroll';


// WEBPACK FOOTER //
// ./src/js/pages/notice.js